import { render, staticRenderFns } from "./EditarConfiguracoesTarjaEnquete.vue?vue&type=template&id=428ca42b&scoped=true"
import script from "./EditarConfiguracoesTarjaEnquete.vue?vue&type=script&lang=js"
export * from "./EditarConfiguracoesTarjaEnquete.vue?vue&type=script&lang=js"
import style0 from "./EditarConfiguracoesTarjaEnquete.vue?vue&type=style&index=0&id=428ca42b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428ca42b",
  null
  
)

export default component.exports